import script from "./NotificationItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./NotificationItem.vue?vue&type=script&setup=true&lang=ts"

import "./NotificationItem.vue?vue&type=style&index=0&id=de01c236&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-de01c236"]])

export default __exports__